<script>
  import { createEventDispatcher } from 'svelte';

  export let index;
  export let label;
  export let styleUrl;
  export let styleObject;

  let inputUrl = styleUrl;
  let styleStr = '';
  let editing = false;
  let error;
  const dispatch = createEventDispatcher();

  $: inputUrl = styleUrl;
  $: if (styleUrl && !styleObject) loadStyle();
  $: if (!editing) styleStr = formatStyleObject(styleObject);

  const formatStyleObject = o => o ? JSON.stringify(o, null, 2) : '';

  const loadStyle = async () => {
    styleObject = null;
    styleStr = '';

    try {
      const req = await fetch(inputUrl);
      if (req.status === 200) {
        styleObject = await req.json();
        error = null;
        editing = false;
        dispatch('styleChange', {
          index,
          url: inputUrl,
          style: styleObject,
        });
      } else {
        throw new Error(`${req.status} ${req.statusText}`)
      }
    }
    catch (e) {
      error = e.message;
    }
  }

  const handleTextareaBlur = () => {
    let newStyleObject;
    try {
      newStyleObject = JSON.parse(styleStr);
    }
    catch (e) {
      error = e.message;
      return;
    }

    if (styleStr === formatStyleObject(styleObject)) return;

    error = null;
    editing = false;
    dispatch('styleChange', {
      index,
      url: '',
      style: newStyleObject,
    });
  };
</script>

<section class="style-section">
  <h2>{label}</h2>
  <div class="input">
    <div>Style URL</div>
    <input
      placeholder="Type URL and press [enter] to load"
      type="text"
      bind:value={inputUrl}
      on:keydown={e => {
        if (e.key === 'Enter') loadStyle()
      }}
    />
  </div>
  {#if error}
    <div class="error">{error}</div>
  {/if}
  <div class="style">
    <textarea 
      on:focus={() => editing = true}
      on:blur={handleTextareaBlur}
      bind:value={styleStr}
    />
  </div>
</section>

<style>
  h2 {
    font-size: 1.2em;
    margin-top: 0;
  }

  .style-section {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
    padding: 1em;
  }

  .style {
    display: flex;
    flex-grow: 1;
  }

  .input input {
    font-size: 0.9em;
    width: 100%;
  }

  textarea {
    flex-grow: 1;
    font-size: 0.8em;
    font-family: monospace;
    width: 100%;
  }

  .error {
    color: red;
    font-size: 0.75em;
  }
</style>
